<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { WoozyDiamonds } from './WoozyDiamonds'
export default {
  mixins: [O3DG2],
  props: {
  },
  methods: {
    setup () {
      this.diamonds = new WoozyDiamonds({
        renderer: this.ctx.renderer,
        onResize: this.onResize,
        onLoop: this.onLoop,
        getScreen: this.getScreen,
        scene: this.ctx.scene,
        camera: this.ctx.camera,
        cubeCam: this.ctx.cubeCam
      })
      this.o3d.add(this.diamonds.o3d)
    }
  },
  beforeDestroy () {
    this.o3d.remove(this.diamonds.o3d)
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>
</style>
